import Section from "../../components/section/section";
import ActivityLogProvider from "../../container/activityLog/context/activityLogContext";
import ActivityLogContainer from "../../container/activityLog/activityLogContainer";

const ActivityLog = (): React.JSX.Element => (
  <Section>
    <ActivityLogProvider>
      <ActivityLogContainer />
    </ActivityLogProvider>
  </Section>
);

export default ActivityLog;
